import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import Card from '../components/Card';

const Home = () => {
  const navigate = useNavigate();

  const menuItems = [
    { path: '/products', icon: '📦', label: 'Товары', color: 'bg-blue-500' },
    { path: '/stock-in', icon: '➕', label: 'Приход', color: 'bg-green-500' },
    { path: '/sales', icon: '💰', label: 'Продажа', color: 'bg-yellow-500' },
    { path: '/orders', icon: '📋', label: 'Заказы', color: 'bg-purple-500' },
    { path: '/scan', icon: '📷', label: 'Сканер', color: 'bg-red-500' },
  ];

  return (
    <div className="h-full flex flex-col p-3">
      <div className="mb-2 flex-shrink-0">
        <h1 className="text-xl font-bold text-gray-900 mb-0.5">Склад</h1>
        <p className="text-xs text-gray-600">Управление складом</p>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-2 flex-1 min-h-0">
        {menuItems.map((item) => (
          <Card
            key={item.path}
            onClick={() => navigate(item.path)}
            className="text-center py-2 flex flex-col justify-center cursor-pointer"
          >
            <div className={`${item.color} w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-1.5 text-xl`}>
              {item.icon}
            </div>
            <h3 className="text-xs font-semibold text-gray-900">{item.label}</h3>
          </Card>
        ))}
      </div>

      <div className="flex gap-2 flex-shrink-0">
        <Button
          variant="primary"
          size="sm"
          className="flex-1"
          onClick={() => navigate('/scan')}
        >
          📷 Сканер
        </Button>
        <Button
          variant="secondary"
          size="sm"
          className="flex-1"
          onClick={() => navigate('/products')}
        >
          Товары
        </Button>
      </div>
    </div>
  );
};

export default Home;

